import 'isomorphic-fetch';
import baseFetch, { createParamString } from '../baseFetch';
import legacyApiFetch from '../legacyApiFetch';
import config from '../../config';
import { getMeterParamsForRequest } from '../../utils/meteringHelper';

export const fetchReport = (spotId, cookies, meter, sds = false, corrected = false) => {
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(
    `/kbyg/spots/reports?${createParamString({ spotId, meterRemaining, sds, corrected })}`,
    { cookies, ...meterHeaders },
  );
};

export const fetchNearbySpots = (spotId, cookies, meter) => {
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(`/kbyg/spots/nearby?spotId=${spotId}&meterRemaining=${meterRemaining}`, {
    cookies,
    ...meterHeaders,
  });
};

export const fetchBuoys = async (legacySpotId, units) => {
  const url = `${config.legacyApi}/mobile/nearby/${legacySpotId}?resources=buoy&unit=${units}&buoys=6`;
  const response = await fetch(url);
  const body = await response.json();
  if (response.status > 200) throw body;
  return body;
};

export const fetchIdealConditions = (legacySpotId) =>
  legacyApiFetch(`/mobile/report/${legacySpotId}`);
